import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { AuthComponent } from './auth/auth.component';
import { LoginNoPrivacyPolicyComponent } from './login-no-privacy-policy/login-no-privacy-policy.component';
import { DocumentContentRendererComponent } from './observer-view/document-content-renderer/document-content-renderer.component';
import { DocumentViewComponent } from './observer-view/document-view/document-view.component';
import { ObserverConferenceComponent } from './observer-view/observer-conference/observer-conference.component';
import { ObserverViewComponent } from './observer-view/observer-view.component';
import { PreptimesComponent } from './observer-view/preptimes/preptimes.component';
import { RatingScaleComponent } from './observer-view/rating-scale/rating-scale.component';
import { SettingsComponent } from './observer-view/settings/settings.component';
import { UploadVideosComponent } from './observer-view/upload-videos/upload-videos.component';
import { VideoShareComponent } from './observer-view/video-share/video-share.component';
import { PartiViewComponent } from './parti-view/parti-view.component';
import { SurveyComponent } from './parti-view/survey/survey.component';
import { ParticipantsummaryComponent } from './participantsummary/participantsummary.component';
import { DisableVideoFeedbackGuard } from './shared/disableVideoFeedback.guard';
import { DocumentContentRendererSingleDocoldComponent } from './shared/document-content-renderer-single-docold/document-content-renderer-single-docold.component';
import { DocumentContentRendererSingleVideoComponent } from './shared/document-content-renderer-single-video/document-content-renderer-single-video.component';
import { DocumentAccessGuard } from './shared/DocumentAccess.guard';
import { IntroductionListComponent } from './shared/introduction-list/introduction-list.component';
import { IsSavedGuard } from './shared/is-saved.guard';
import { IsModeratorGuard } from './shared/ismoderator.guard';
import { documentviewResolver } from './shared/resolver/DocumentviewResolver';
import { initPrepTimeServiceResolver } from './shared/resolver/InitPrepTimeServiceResolver';
import { introductionViewResolver } from './shared/resolver/IntroductionViewResolver';
import { modPrepTimeResolver } from './shared/resolver/mod-prep-time.resolver';
import { packContentResolver } from './shared/resolver/PackContentResolver';
import { pageAnnotationResolver } from './shared/resolver/PageAnnotationResolver';
import { participantSummaryNewResolver } from './shared/resolver/ParticipantSummaryNewResolver';
import { participantVideoResolver } from './shared/resolver/ParticipantVideoResolver';
import { surveyResultResolver } from './shared/resolver/SurveyResultResolver';
import { videoResolver } from './shared/resolver/VideoResolver';
import { ResultconferenceGuard } from './shared/resultconference.guard';
import { SeconddeviceComponent } from './shared/seconddevice/seconddevice.component';
import { SeconddeviceAuthComponent } from './shared/seconddeviceauth/seconddeviceauth.component';
import { VideoComponent } from './shared/video/video.component';

const appRoutes: Routes = [
  {
    path: 'connect2nddevice',
    component: SeconddeviceAuthComponent,
  },
  {
    path: 'auth',
    component: AuthComponent
  },
  {
    path: 'pv44',
    pathMatch: 'full',
    component: LoginNoPrivacyPolicyComponent
  },
  {
    path: 'observer',
    resolve: {
      pack: packContentResolver
    },
    children: [
      {
        path: '',
        component: ObserverViewComponent,
        canActivateChild: [IsSavedGuard],
        children: [
          {
            path: 'introduction',
            component: AppComponent,
            children: [
              {
                path: 'docs',
                component: IntroductionListComponent,
                resolve: {
                  pack: packContentResolver
                },
              },
              {
                /* INTRO DOCS **/
                path: 'docs/video/:selectedvideo',
                component: DocumentContentRendererSingleVideoComponent,
                resolve: {
                  video: videoResolver
                },
              },
              {
                path: 'docs/:selecteddoc/:page',
                component: DocumentContentRendererSingleDocoldComponent,
                resolve: {
                  pack: introductionViewResolver
                }
              }
            ]
          },
          {
            path: 'share',
            component: VideoShareComponent,
            resolve: {
              pack: packContentResolver
            },
          },
          {
            path: 'settings',
            component: SettingsComponent,
            resolve: {
              pack: packContentResolver
            },
          },
          {
            path: 'conference',
            canActivate: [ResultconferenceGuard],
            component: ObserverConferenceComponent,
            children: [
              {
                path: ':participantid',
                component: ParticipantsummaryComponent,
                resolve: {
                  pack: packContentResolver,
                  participantSummary: participantSummaryNewResolver,
                  annotations: pageAnnotationResolver
                },
              },
              {
                path: ':participantid/documentview/:day',
                component: ParticipantsummaryComponent,
                resolve: {
                  pack: documentviewResolver,
                  participantSummary: participantSummaryNewResolver
                },
                children: [
                  {
                    path: ':selectedevent/docs/:selecteddoc/:page/:userid',
                    component: DocumentContentRendererSingleDocoldComponent,
                    resolve: {
                      pack: pageAnnotationResolver
                    },
                  },
                ]
              }
            ],
            resolve: {
              pack: packContentResolver
            },
          },
          {
            path: 'preptimes',
            canActivate: [IsModeratorGuard],
            component: PreptimesComponent,
            resolve: {
              pack: modPrepTimeResolver
            },
          },
          {
            path: 'videoupload',
            component: UploadVideosComponent,
            resolve: {
              pack: packContentResolver
            },
          },
          {
            path: 'documentview',
            redirectTo: 'documentview/0',
            pathMatch: 'full'
          },
          {
            path: 'documentview/:day',
            component: DocumentViewComponent,
            resolve: {
              pack: documentviewResolver
            },
            children: [
              {
                path: ':selectedevent',
                redirectTo: ':selectedevent/docs',
                pathMatch: 'full'
              },
              {
                path: ':selectedevent/docs',
                component: DocumentContentRendererComponent,
                resolve: {
                  pack: documentviewResolver
                },
              },
              {
                path: ':selectedevent/rating/:userid/:timeblockid',
                component: RatingScaleComponent,
                resolve: {
                  pack: documentviewResolver,
                  //rating: RatingResolver,
                  //observationForm: ObservationFormResolver
                },
              },
              {
                path: ':selectedevent/docs/video/:selectedvideo',
                component: DocumentContentRendererSingleVideoComponent,
                resolve: {
                  video: videoResolver
                },
              },
              {
                path: ':selectedevent/docs/:selecteddoc/:page/',
                component: DocumentContentRendererSingleDocoldComponent,
                resolve: {
                  pack: documentviewResolver
                },
                data: {
                  debug: true,
                  hideSidebar: true
                }
              },
              {
                path: ':selectedevent/docs/:selecteddoc/:page',
                component: DocumentContentRendererSingleDocoldComponent,
                resolve: {
                  pack: pageAnnotationResolver,
                },
                data: {
                  hideSidebar: true
                }
              },
              {
                path: ':selectedevent/docsold/:selecteddoc/:page/:userid',
                component: DocumentContentRendererSingleDocoldComponent,
                resolve: {
                  pack: pageAnnotationResolver
                },
              },
              {
                path: ':selectedevent/docs/:selecteddoc/:page/:userid',
                component: DocumentContentRendererSingleDocoldComponent,
                resolve: {
                  pack: pageAnnotationResolver
                },
              },
              {
                path: ':selectedevent/survey/:surveyid',
                component: SurveyComponent,
                resolve: {
                  pack: documentviewResolver,
                  surveyresult: surveyResultResolver
                }
              }
            ]
          },
        ]
      }
    ]
  },
  {
    path: 'participant',
    resolve: {
      pack: packContentResolver
    },
    children: [
      {
        path: '',
        component: PartiViewComponent,
        resolve: {
          init: initPrepTimeServiceResolver
        },
        children: [
          {
            path: 'introduction',
            component: AppComponent,
            children: [
              {
                path: 'docs',
                component: IntroductionListComponent,
                resolve: {
                  pack: packContentResolver
                },
              },
              {
                path: 'docs/video/:selectedvideo',
                component: DocumentContentRendererSingleVideoComponent,
                resolve: {
                  video: videoResolver
                },
              },
              {
                path: 'docs/:selecteddoc/:page',
                component: DocumentContentRendererSingleDocoldComponent,
                resolve: {
                  pack: introductionViewResolver
                }
              },
            ]
          },
          {
            path: 'documentview',
            redirectTo: 'documentview/0',
            pathMatch: 'full'
          },
          {
            path: 'documentview/:day',
            component: DocumentViewComponent,
            resolve: {
              pack: documentviewResolver
            },
            children: [
              {
                path: ':selectedevent',
                redirectTo: ':selectedevent/docs',
                pathMatch: 'full'
              },
              {
                path: ':selectedevent/docs',
                component: DocumentContentRendererComponent,
                resolve: {
                  pack: documentviewResolver
                },
              },
              {
                path: ':selectedevent/docs/video/:selectedvideo',
                component: DocumentContentRendererSingleVideoComponent,
                resolve: {
                  video: videoResolver
                },
              },
              {
                path: ':selectedevent/docs/:selecteddoc/:page/',
                canActivate: [DocumentAccessGuard],
                component: DocumentContentRendererSingleDocoldComponent,
                resolve: {
                  pack: documentviewResolver
                },
              },
              {
                path: ':selectedevent/docs/:selecteddoc/:page/:userid',
                component: DocumentContentRendererSingleDocoldComponent,
                resolve: {
                  pack: pageAnnotationResolver
                },
              },
              {
                path: ':selectedevent/selfestimation',
                component: VideoComponent,
                resolve: {
                  pack: documentviewResolver,
                  videos: participantVideoResolver
                }
              },
              {
                path: ':selectedevent/selfrecording',
                canActivate: [DisableVideoFeedbackGuard],
                component: VideoComponent,
                resolve: {
                  pack: documentviewResolver,
                  videos: participantVideoResolver
                }
              },
              {
                path: ':selectedevent/survey/:surveyid',
                component: SurveyComponent,
                resolve: {
                  pack: documentviewResolver,
                  surveyresult: surveyResultResolver
                }
              }
            ]
          },
          {
            path: 'settings',
            component: SettingsComponent,
            resolve: {
              pack: packContentResolver
            },
          },
          {
            path: 'videoshare',
            component: VideoShareComponent,
            resolve: {
              pack: packContentResolver
            },
          }
        ]
      },
      {
        path: '2nddevice/:tbid',
        canActivate: [DisableVideoFeedbackGuard],
        component: SeconddeviceComponent,
        resolve: {
          pack: documentviewResolver,
          videos: participantVideoResolver
        }
      }
    ]
  },
  {
    path: '',
    component: AuthComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      { useHash: true, enableTracing: false })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
